import { ref } from 'vue'

/**
 * 轻量提示条。没有引第三方 toast 库 —— 一期只需要「成功 / 失败」两种一行提示，
 * 引一个库要连带它的主题系统，不划算。
 */
export interface ToastItem {
  id: number
  tone: 'ok' | 'bad' | 'info'
  text: string
}

const items = ref<ToastItem[]>([])
let seq = 0

function push(tone: ToastItem['tone'], text: string, ms = 3600) {
  const id = ++seq
  items.value.push({ id, tone, text })
  setTimeout(() => {
    items.value = items.value.filter((t) => t.id !== id)
  }, ms)
}

export function useToast() {
  return {
    items,
    success: (text: string) => push('ok', text),
    error: (text: string) => push('bad', text, 5000),
    info: (text: string) => push('info', text),
    dismiss: (id: number) => {
      items.value = items.value.filter((t) => t.id !== id)
    },
  }
}
